import "firebase/compat/firestore";
import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsUtil, fetchIncompleteProductsUtil } from "../../../utility";

const useProducts = () => {
  const dispatch = useDispatch();
  const { all_products = [] } = useSelector((state) => state.products);
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(() => {
    const p = parseInt(localStorage.getItem("productPage"), 10);
    return !isNaN(p) ? p : 1;
  });
  const [pageSize, setPageSize] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [status, setStatus] = useState("publish");
  const [selectedData, setSelectedData] = useState([]);
  const [searchValue, setSearchValue] = useState(() => {
    return localStorage.getItem("productSearch") || "";
  });
  const [mergeItemModal, setMergeItemModal] = useState(false);
  const toggleMergeModal = () => setMergeItemModal((prev) => !prev);
  const [createItemModal, setCreateItemModal] = useState(false);
  const toggleCreateModal = () => setCreateItemModal((prev) => !prev);
  const [showItemModal, setShowItemModal] = useState(false);
  const toggleShowItemModal = () => setShowItemModal((prev) => !prev);
  const [selectedProduct, setSelectedProduct] = useState();

  const gettingProducts = useCallback((onSuccess) => {
    if (status === "incomplete") {
      fetchIncompleteProductsUtil({
        page,
        pageSize,
        setLoading,
        dispatch,
        setTotalPages,
        onSuccess,
      });
    } else {
      const isCompleteVal = status === "completed" ? true : null;
      const actualStatus = status === "completed" ? "publish" : status;
      fetchProductsUtil({
        page,
        search: searchValue ?? "",
        pageSize,
        status: actualStatus,
        setLoading,
        dispatch,
        setTotalPages,
        onSuccess,
        isComplete: isCompleteVal,
      });
    }
  }, [page, searchValue, status, pageSize, dispatch]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingProducts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [gettingProducts]);

  return {
    products: all_products,
    status,
    setStatus,
    searchValue,
    setSearchValue,
    loading,
    setSelectedData,
    selectedData,
    createItemModal,
    setCreateItemModal,
    toggleCreateModal,
    selectedProduct,
    setSelectedProduct,
    showItemModal,
    toggleShowItemModal,
    user,
    totalPages,
    page,
    setPage,
    pageSize,
    setPageSize,
    gettingProducts,
    toggleMergeModal,
    mergeItemModal
  };
};

export default useProducts;

